import React, { useEffect, useMemo, useState } from "react";

function normalize(value = "") {
    return String(value).toLowerCase().trim();
}

export default function HowItWorksFaq({ items = [] }) {
    const [query, setQuery] = useState("");
    const [openKey, setOpenKey] = useState(items[0]?.q || "");

    const filteredItems = useMemo(() => {
        const needle = normalize(query);
        if (!needle) return items;

        return items.filter((item) =>
            normalize(`${item.q} ${item.a}`).includes(needle)
        );
    }, [items, query]);

    useEffect(() => {
        if (!filteredItems.length) {
            setOpenKey("");
            return;
        }

        const hasOpenItem = filteredItems.some((item) => item.q === openKey);
        if (!hasOpenItem) {
            setOpenKey(filteredItems[0].q);
        }
    }, [filteredItems, openKey]);

    return (
        <div className="how-faq">
            <div className="how-faq-header">
                <h3>Frequently Asked Questions</h3>
                <p>Search the FAQ or open a question to see the full answer.</p>
            </div>

            <div className="how-faq-shell">
                <div className="how-faq-toolbar">
                    <label className="how-faq-search">
                        <input
                            type="search"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            placeholder="Search the FAQ"
                            aria-label="Search the FAQ"
                        />
                    </label>

                    {query ? (
                        <button
                            type="button"
                            className="how-faq-clear"
                            onClick={() => setQuery("")}
                        >
                            Clear
                        </button>
                    ) : null}
                </div>

                {filteredItems.length ? (
                    <div className="how-faq-list">
                        {filteredItems.map((item, index) => {
                            const panelId = `how-faq-panel-${index}`;
                            const isOpen = openKey === item.q;

                            return (
                                <article
                                    key={item.q}
                                    className={`how-faq-entry${isOpen ? " is-open" : ""}`}
                                >
                                    <h4 className="how-faq-question">
                                        <button
                                            type="button"
                                            className="how-faq-trigger"
                                            aria-expanded={isOpen}
                                            aria-controls={panelId}
                                            onClick={() => setOpenKey(isOpen ? "" : item.q)}
                                        >
                                            <span>{item.q}</span>
                                            <span className="how-faq-icon" aria-hidden="true" />
                                        </button>
                                    </h4>

                                    <div
                                        id={panelId}
                                        className="how-faq-panel"
                                        hidden={!isOpen}
                                    >
                                        <div className="how-faq-panel-inner">
                                            <p>{item.a}</p>
                                        </div>
                                    </div>
                                </article>
                            );
                        })}
                    </div>
                ) : (
                    <div className="how-faq-empty">
                        No FAQ answers matched <strong>“{query}”</strong>. Try a different keyword or clear the search.
                    </div>
                )}
            </div>
        </div>
    );
}
